/**
 * DeliveryAddressesProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'

import DeliveryAddressesContext from './delivery-addresses-context'
import {
  createDeliveryAddresses,
  deleteDeliveryAddresses,
  fetchDeliveryAddresses,
  updateDeliveryAddresses
} from './delivery-addresses-api'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export default function DeliveryAddressesProvider({ children }) {
  const contextValue = {
    createDeliveryAddresses,
    deleteDeliveryAddresses,
    fetchDeliveryAddresses,
    updateDeliveryAddresses
  }
  return (
    <DeliveryAddressesContext.Provider value={contextValue}>
      {children}
    </DeliveryAddressesContext.Provider>
  )
}
